export const CSS_CORRECTION_REASON_MAX_LENGTH = 500;

export function normalizeCssCorrectionReason(reason: string): string {
  return reason.replace(/\r\n?/g, "\n").replace(/\t/g, " ").trim();
}

/** Keep the same normalization and control-character restrictions as the API. */
export function getCssCorrectionReasonError(reason: string): string | null {
  if (
    /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F\u200B-\u200F\u202A-\u202E\u2060-\u206F\uFEFF]/u.test(
      reason
    )
  ) {
    return "修正理由に使用できない文字が含まれています";
  }
  const normalized = normalizeCssCorrectionReason(reason);
  if (!normalized) {
    return "修正理由を入力してください";
  }
  if (normalized.length > CSS_CORRECTION_REASON_MAX_LENGTH) {
    return "修正理由は500文字以内で入力してください";
  }
  return null;
}
